<template>
  <ValidationProvider v-slot="{ errors }" class="time-picker" :rules="rules">
    <input type="hidden" :value="value" />
    <p v-if="title" class="time-picker_title">{{ $t(title) }}<span v-if="required">*</span></p>
    <div class="time-picker_content">
      <DatePicker
        ref="input"
        :type="type"
        :lang="lang"
        class="picker"
        :class="{ error: errors.length > 0 }"
        :value="_value"
        :placeholder="placeholder"
        :clearable="clearable"
        :disabled-date="$_disabledDate"
        :show-second="false"
        :format="format"
        :appendToBody="popupLeft ? false : true"
        :popupStyle="popupLeft ? { left: 0 } : null"
        @input="$_onInput($event)"
      >
        <i slot="icon-calendar">
          <i class="icon-time picker-icon" />
        </i>
        <i slot="icon-clear">
          <i class="icon-cancel picker-icon" />
        </i>
      </DatePicker>
    </div>
    <div v-if="errors.length > 0" class="invalid-text">
      <i class="icon-warning invalid-icon" />
      <p v-for="(text_e, text_k) in errors" :key="text_k" class="text">
        {{ $t(text_e) }}
      </p>
    </div>
  </ValidationProvider>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-tw';

extend('required', {
  ...required,
  message: '此項目為必填',
});
export default {
  name: 'TimePicker',
  components: {
    ValidationProvider,
    DatePicker,
  },
  props: {
    type: {
      type: String,
      default: 'time',
    },
    rules: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },

    disabledDate: {
      type: Function,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    value: {},
    placeholder: {
      type: String,
      default() {
        return this.$t('HH:mm');
      },
    },
    format: {
      type: String,
      default: 'HH:mm',
    },
    startDate: {
      type: String,
      default: null,
    },
    popupLeft: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    lang: {
      formatLocale: {
        firstDayOfWeek: 7,
      },
    },
  }),
  computed: {
    _value() {
      if (this.value) {
        return new Date(this.value);
      } else {
        return null;
      }
    },
  },
  watch: {
    value() {
      this.time = this.value;
    },
  },
  mounted() {
    this.time = this.value;
  },
  methods: {
    onChange(e) {
      this.$emit('input', e);
      this.time = e;
    },
    $_disabledDate(date) {
      if (this.startDate) {
        if (this.$moment(date).isBefore(this.startDate)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    $_onInput($event) {
      if (!$event) {
        return this.$emit('input', null);
      }
      this.$emit('input', this.$moment($event));
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/time-picker';
</style>
